export default `
# Program
`



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/program/text.js